import { useRef } from 'react';

import { FAQ } from '@components/FAQ';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupBhcWhatsCoveredFeatureExpanded } from '@tracking/trackingEvents';

import { getTopics } from './topics';

const ListCovered = () => {
  const ref = useRef(null);
  const { trackingContexts } = useTrackingContext();
  const trackExpanded = useTrackSignupBhcWhatsCoveredFeatureExpanded();

  // INFO: Reusing the FAQ component for its design, even though the content is not a true FAQ.
  // Topics are mapped to align with the component's structure.
  const mappedTopics = getTopics().map((topic) => ({
    ...topic,
    question: topic.title,
    answer: topic.details,
  }));

  const sections = [
    {
      id: 'root',
      title: '',
      topics: mappedTopics,
    },
  ];

  const handleAccordionChange = (feature: string, isExpanded: boolean) => {
    if (!isExpanded) {
      return;
    }

    trackExpanded(
      {
        feature,
      },
      { contexts: trackingContexts }
    );
  };

  return (
    <FAQ
      ref={ref}
      sections={sections}
      showTitle={false}
      onAccordionChange={handleAccordionChange}
      embed
    />
  );
};

export { ListCovered };
